<script setup>
  import * as Icons from '@/icons'
  import { ref } from 'vue'

  const props = defineProps({
    name: {
      type: String,
      default: undefined,
      required: true
    },
    fill: {
      type: String,
      default: 'currentColor'
    },
  })

  const svg = ref('')
  svg.value = Icons[props.name]

</script>

<template>
  <span
    v-html="svg"
  />
</template>
